import { render, staticRenderFns } from "./DetalheFormComponent.vue?vue&type=template&id=6f11f98a&"
import script from "./DetalheFormComponent.vue?vue&type=script&lang=js&"
export * from "./DetalheFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports